/**
 * @file OrderRefundAlert.tsx
 * @description Предупреждение о возврате средств в шапке карточки заказа.
 *
 * Риск, который закрывает блок: менеджер отгружает товар клиенту, которому
 * деньги уже вернули. Признак берём из того же источника, что и красная
 * строка «Средства возвращены» в реестре (`order-summary-lines`).
 *
 * Ссылка ведёт на вкладку «Платежи» — вкладки карточки живут в state, поэтому
 * это кнопка-якорь, а не router-link.
 */

import { Alert } from "../ui/alert";
import type { OrderDto } from "../../lib/api-orders";
import { ORDER_REFUND_TEXT, isOrderRefunded } from "../../lib/order-summary-lines";

interface Props {
  order: OrderDto;
  /** Открыть вкладку «Платежи» карточки заказа. */
  onOpenPayments: () => void;
}

export function OrderRefundAlert({ order, onOpenPayments }: Props) {
  if (!isOrderRefunded(order)) return null;

  return (
    // На 360px алерт занимает всю ширину, текст и ссылка переносятся колонкой.
    <Alert severity="error" title="Возврат средств">
      <div className="flex flex-col items-start gap-1">
        <span className="break-words">{ORDER_REFUND_TEXT.alert}</span>
        <button
          type="button"
          onClick={onOpenPayments}
          className="inline-flex min-h-11 items-center text-sm font-medium text-primary underline underline-offset-2 hover:no-underline"
        >
          Проверить платежи
        </button>
      </div>
    </Alert>
  );
}
